<editor
    [class.cmps-comment--hide-toolbar]="!_showToolbar"
    [class.cmps-comment--has-focus]="_showToolbar"
    [init]="_init"
    (onFocus)="focus()"
    (onBlur)="blur()"
    [ngModel]="_content"
    (ngModelChange)="_onContentChange($event)"
    *ngIf="_show"
>
</editor>
